import React, { useState } from 'react';
import '../../styles/T_foundation.scss'; 

interface Props {
  onClose: () => void;
  onConfirm: (foundation: string) => void;
}

const FoundationModal: React.FC<Props> = ({ onClose, onConfirm }) => {
  const [selected, setSelected] = useState<string>('');

  const foundations = [
    "France Philippines United Action (FPUA)",
    "Make A Wish Foundation",
    "BNI Foundation",
  ];

  return (
    <div className="foundation-modal-overlay">
      <div className="foundation-modal">
        <h2>Select a Foundation to Support</h2>
        <ul>
          {foundations.map((foundation) => (
            <li key={foundation}>
              <label>
                <input
                  type="radio"
                  name="foundation"
                  value={foundation}
                  checked={selected === foundation}
                  onChange={() => setSelected(foundation)}
                />
                {foundation}
              </label>
            </li>
          ))}
        </ul>
        <div className="modal-actions">
          <button onClick={onClose} className="cancel-btn">Cancel</button>
          <button
            className="confirm-btn"
            onClick={() => selected && onConfirm(selected)}
            disabled={!selected}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default FoundationModal;
